/**
 * @description Clock status indicator badge
 *
 * Key features:
 * - Visual status: Clocked In (green), On Break (yellow), Clocked Out (gray)
 * - Pulsing indicator for active states
 */

import React from 'react';

const StatusBadge = ({ status }) => {
  const config = {
    clocked_in: { label: 'Clocked In', color: 'bg-green-500', textColor: 'text-green-400', pulse: true },
    on_break: { label: 'On Break', color: 'bg-yellow-500', textColor: 'text-yellow-400', pulse: true },
    clocked_out: { label: 'Clocked Out', color: 'bg-slate-500', textColor: 'text-slate-400', pulse: false },
  };

  const { label, color, textColor, pulse } = config[status] || config.clocked_out;

  return (
    <div className="flex items-center gap-2">
      <span className="relative flex h-3 w-3">
        {pulse && (
          <span className={`animate-ping absolute inline-flex h-full w-full rounded-full ${color} opacity-75`} />
        )}
        <span className={`relative inline-flex rounded-full h-3 w-3 ${color}`} />
      </span>
      <span className={`text-sm font-medium ${textColor}`}>{label}</span>
    </div>
  );
};

export default StatusBadge;
